module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_45.59f4ccfc.jpg";